import { getToken, onMessage } from "firebase/messaging";
import { useDispatch } from "react-redux";
import { setToken } from "src/store/slices/userSlice";
import { useEffect } from "react";
import { CustomToast } from "src/components/CustomToast";
import toast from 'react-hot-toast';
import { messaging } from "./firebaseConfig";
 
 
const NotificationHandler = () => {
  const dispatch = useDispatch();
  const REACT_APP_VAPID_KEY = "BArvVAupojGPFL14_dcJJ9J776rtw-Hqi7tpaxPlnbBhUPEO23hpdj5_FHLivNZVxKN4IV7wZdDNrji0u30dd5I";
  
  const requestPermission = async () => {
    try {
      const permission = await Notification.requestPermission();
      if (permission === "granted") {
          const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
          const token = await getToken(messaging, {
            vapidKey: REACT_APP_VAPID_KEY,
            serviceWorkerRegistration: registration
          });
          if (token) dispatch(setToken(token));
      } else if (permission === "denied") {
        console.warn("Notification permission denied");
      }
    } catch (err) {
      console.error("Error getting notification permission:", err);
    }
  };
 
  useEffect(() => {
    requestPermission();
 
    const unsubscribe = onMessage(messaging, (payload) => {
      toast.custom((t) => <CustomToast payload={payload} t={t} />);
       if (Notification.permission === "granted") {
        const title = payload?.notification?.title ?? "New Notification";
        const options = {
          body: payload?.notification?.body ?? "",
        };
        new Notification(title, options);
      }
    });
 
    return () => unsubscribe();
  }, []);
 
  return null;
};
 
export default NotificationHandler;